<template>

  <section class="article event" style="overflow-y: auto;">
    <div class="article-wrap">
      <div
        v-if="!place"
        class="article-none"
        style="display: flex; align-items: center; justify-content: center; height: 100vh"
      >
        <img src="https://media.giphy.com/media/dYiUCF6g3efVZ45kr0/giphy.gif" />
      </div>

      <div v-if="place" class="article-content">
        <div class="event-header" :style="{ backgroundImage: 'url(' + getCover() + ')' }">
          <div class="map-button" @click="backToMap()">
            <img src="@/assets/images/icons/marker.svg" width="18px" />
            <p>Показать на карте</p>
          </div>
          <div class="event-back event-back_places" @click="backToList()">
            <font-awesome-icon icon="list-ul" />
            <p>Показать список</p>
          </div>
        </div>

        <div class="content">
          <div class="content-wrap">
            <h1 class="event-title">{{ place.title }}</h1>
            <div class="event-info">
              <p class="event-info__place">{{ place.country || place.state ? place.country + ', ' + place.state : 'Без места' }}</p>
              <p class="event-info__item">{{ place.views + 1 }} просмотров</p>
              <!-- <p class="event-info__item">{{ getDate() }}</p> -->
            </div>
            <div class="event-category">
              <div
                @click="setCategoryFilter(cat)"
                v-for="cat in place.sports"
                :key="cat.id"
                class="event-category__item"
                :class="cat.color"
              >
                {{ cat.ru }}
              </div>
            </div>
            <Weather :coords="{lat: place.latitude, lng: place.longitude}" v-if="place" />
            <div class="content-body">
              <!-- eslint-disable -->
              <slot v-for="(element, index) in place.content">
                <p v-if="element.type == 'paragraph'" :key="index" v-html="getParagraph(element.value)"></p>
                <h3 v-if="element.type == 'h3'" :key="index">{{element.value}}</h3>
                <div v-if="element.type == 'image'" :key="index" class="content-images" :class="{'no-padding': imagePadding(index)}">
                  <div class="content-images__image" 
                    :class="getImageClass(element.value)" 
                    v-for="(image, index_image) in element.value" 
                    :key="index_image" 
                    @click="showFullPhoto(element.value, image)">
                    <img :src="image.url" />
                  </div>
                </div>
                <iframe width="100%" height="450" :src="element.value" title="YouTube video player" v-if="element.type == 'youtube'" :key="index" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </slot>
              <!-- eslint-enable -->
            </div>
            <div class="event-panel">

              <Like 
                :active="hasLike" 
                :likes="place.likes" 
                :size="28"
                @click.native="sendLike()"
              />
              <div class="share" @click="sharing = !sharing">
                <Sharing 
                  v-if="sharing"
                  :link="'https://wiildwood.online'+$route.path"
                  :title="place.title"
                  :description="getDescription"
                  :position="'top'"
                  :media="'https://storage.yandexcloud.net/wildwood/test/img.png'"
                 />
                <Reply />
                <p>Поделиться</p>
              </div>
            </div>
          </div>
        </div>

        <div class="block translation" v-if="place.photos && place.photos.length > 0">
          <h4>Фотографии</h4>
          <div class="block-body">
            <PhotoSlider :items="place.photos" :canDelete="isAuthor" @deletePhoto="deletePhoto" />
          </div>
        </div>

        <div class="block similar" v-if="place.events && place.events.length > 0">
            <h4>События этого места</h4>
            <div class="block-body">
              <EventsPlace :items="place.events" />
            </div>
        </div>
        <!-- <PostPlace :key="place.id" :place="place" /> -->

        <Comments placeholder="Напишите отзыв о месте" title="Отзывы" :place="place" />
      </div>
    </div>
    <Panel 
      v-if="place"
      :place="place"
      @setComplain="$emit('setComplain', {place_id: place.id, type: 'place'})"
      @deletePlace="$emit('deletePlace')"
      :isAuthor="isAuthor" />
    <EventPseudo v-if="!place" />
  </section>
  
</template>

<script>
import html2canvas from 'html2canvas';

export default {
  props: {
    place: {
      type: Object,
      required: false
    },
  },
  data() {
    return {
      ids: this.$router.currentRoute.params['id'],
      content: '',
      joined: false,
      sharing: false,
      likes: null,
      more: false,
      weather: null
    };
  },
  components: {
    PhotoSlider: () => import('@/components/Sliders/PhotoSlider'),
    Comments: () => import('@/components/Blocks/Comments'),
    Like: () => import('@/components/Lenta/Like'),
    Reply: () => import('@/components/Lenta/Reply'),
    EventsPlace: () => import('@/components/Sliders/EventsPlace'),
    EventPseudo: () => import('@/components/Pseudo/EventPseudo'),
    Sharing: () => import('@/components/UI/Sharing'),
    // PostPlace: () => import('./PostPlace'),
    Panel: () => import('./Panel'),
    Weather: () => import('./Weather'),
  },
  computed: {
    isAuthor() {
      return this.getUser ? Number(this.place.author_id) == Number(this.getUser.id) : null
    },
    hasLike() {
      return this.place && this.place.likes.length > 0 && this.getUser ? this.place.likes.find(like => Number(like.user) === this.getUser.id) ? true : false : false
    },
    getLikes() {
      let eLikes = this.place.likes ? this.place.likes.length : 0;
      return this.likes ? this.likes.length : eLikes;
    },
    getUser() {
      return this.$store.getters.getAuthUser
    },
    getDescription() {
      let description = this.place.content.find(block => block.type === 'paragraph');
      return description && description.value ? description.value : document.querySelector('meta[property="og:description"]');
    }
  },
  methods: {
    deletePhoto({photo, index}) {
      this.$store.dispatch('deleteImage', {key: photo.key ? photo.key : photo.url, place_photo: photo.id})
      .then((res) => {
        console.log(res,'res');
        this.place.photos.splice(index, 1)
      });
    },
    imagePadding(index) {
      let nextBlock = this.place.content[index + 1];
      return nextBlock && nextBlock.type === 'image' 
    },
    setDestination() {
      this.$store.dispatch('setDestinationId', this.place.id)
      this.$store.dispatch('setTransport', true)
    },
    screenShot(sharing) {
      if (sharing) {
        html2canvas(document.querySelector(`.article .post[data_id="${this.place.id}"]`),
          { letterRendering: 1, 
            allowTaint : true
          }).then(canvas => {
            document.body.appendChild(canvas);
          })
      }
    },
    getParagraph(value) {
      return this.escapeLinks(value.replace(/\n/g, '<br>'))
    },
    escapeLinks(message) {
        const regexp = new RegExp(/([^"=]{2}|^)((https?|ftp):\/\/\S+[^\s.,> )\];'"!?])/);
        const subst = '$1<a href="$2" target="_blank">$2</a>'; 
        return message.replace(regexp, subst);
    },
    async sendLike() {
      this.getUser ? '' : this.$router.push({name: 'login'})
      if (this.hasLike) {
        await this.$store.dispatch('removeLovingPlace', {user: this.getUser.id, place: this.place.id});
        this.place.likes = this.place.likes.filter(like => like.user !== this.getUser.id);
      } else { 
        let like = await this.$store.dispatch('addLovingPlace', {
          user: this.getUser.id, 
          place_id: this.place.id, 
          place: { 
            id: this.place.id,
            hash: this.place.hash,
            author_id: this.place.author_id,
            title: this.place.title
          }});
        this.place.likes.push(like);
        this.$store.dispatch('addNotification', {message: 'Любимые места можно посмотреть в профиле, в разделе "Места -> Любимые"'})
      }
    },
    setCategoryFilter(cat) {
      cat.active = true;
      this.$store.dispatch('changeSports', cat);
    },
    getImageClass(images) {
      let result = '';
      switch (images.length) {
        case 1:
          result = 'size_one';
          break;
        case 2:
          result = 'size_two';
          break;
        case 3:
          result = 'size_tree';
          break;
        case 4:
          result = 'size_four';
          break;
        case 5:
          result = 'size_five';
          break;
        case 6:
          result = 'size_six';
          break;

        default:
          break;
      }
      return result;
    },
    async showFullPhoto(photos, active) {
      let images = [];
      let bloksImages = await this.place.content.filter(block => block.type === 'image');
      bloksImages.forEach(block => {
        images = images.concat(block.value)
      })
      let index = images.indexOf(active);
      this.$store.dispatch('setPhotos', {photos: images , active: index})
      this.$store.dispatch('setPhotosState', true)
    },
    backToMap() {
      this.$store.dispatch('changeListPlaces', false);
      this.$store.dispatch('changeModePlaces', 'map');
      this.$store.dispatch('setMapZoom', 13);
    },
    backToList() {
      this.$store.dispatch("changeListPlaces", true);
      this.$router.push('/places');
    },
    getCover() {
      return this.place.cover
        ? this.place.cover
        : 'https://images.unsplash.com/photo-1576967646301-b68a028ea17a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1353&q=80';
    },
    async editPlace() {
      let place = this.place;
      await this.$store.dispatch('editPlace', place)
      this.place.sports.forEach(element => {
          this.$store.dispatch('changeSportsNew', element)
      })
    }
  },
  watch: {
    // 'sharing': 'screenShot',
  }
};
</script>
<style lang="stylus" scoped>
.article .post
  position fixed
  max-width 320px
  z-index 100
</style>